/* Styles */
import "../style/base/_common.scss";
import "../style/components/_box.scss";
import "../style/components/_utilities.scss";
import "../style/components/_transitions.scss";
import "../style/components/_grid.scss";
import "../style/components/_nav.scss";
import "../style/components/_modal.scss";
import "../style/components/_breadcrumb.scss";
import "../style/components/_buttons.scss";
import "../style/components/_images.scss";
import "../style/components/_forms.scss";
import "../style/components/_card.scss";
import "../style/components/_media.scss";
import "../style/layout/_cookie.scss";
import "../style/layout/_map.scss";
import "../style/layout/_header.scss";
import "../style/layout/_listing.scss";
import "../style/layout/_insertion.scss";
import "../style/layout/_filters.scss";
import "../style/layout/_pagination.scss";
import "../style/layout/_footer.scss";
import "../style/vendor/_jquery-ui.scss";
import "../style/vendor/_siema.scss";
import "../style/pages/agency-listing.scss";

/* JS */
import "./components/menu";
import "@wikicasa/common/lazy";
import "@wikicasa/common/select";

import * as Listing from "./components/listing";
import * as Common from "@wikicasa/common/common";

import "core-js/modules/es.array.iterator";
import type {IContact} from "./components/contact";

declare global {
    interface Window {
        _serializedAgencySearchBean: string;
    }
}
let Filters: any;

let Contact: IContact;

$(() => {

    $("#ag-disclaimer").modal("show");

    Listing.init({
        list: "#list-agencies",
        getMapMarkers: getMapMarkers,
        buildInfoWindow: buildInfoWindow
    });

    Common.observe("#filters-form-main, #filters-form-mobile", (elem: any, observer: IntersectionObserver) => {
        import(/* webpackChunkName: "chunks/filters" */ "./components/filters").then((module: any) => {

            Filters = module;

            Filters.init({
                map: "#filters-map",
                formMain: "#filters-form-main",
                formExtend: "#filters-form-extend",
                formMobile: "#filters-form-mobile",
            });

            // Add macroTypologyID
            const search = $.extend(true, {macroTypologyId: Common.MACROTYPOLOGY_AGENCY}, Common.getSearch());

            Filters.ready(() => Filters.loadSearch(search));
        });

        observer.disconnect();
    });

    $("#list-agencies").on("click", "[data-phone]", function (e: JQuery.Event) {
        e.preventDefault();
        e.stopPropagation();

        const self = this;

        import(/* webpackChunkName: "chunks/contact" */ "./components/contact").then((module: any) => {

            if (!Contact) {
                Contact = module;
                Contact.init();
            }

            Contact.showPhone(e, $(self));
        });
    });

    $("#disclaimer").modal("show");
});


function buildInfoWindow(ids: Array<number>): Promise<string> {

    return new Promise((resolve: (str: string) => void) => {

        getAgenciesData(ids).done((data: any) => {

            if (!data)
                return;

            let html = "<p class=\"mb-10\">Agenzie</p>";
            html += `<ul class="list-multiple list-unstyled mb-0">${buildListHtml(data)}</ul>`;

            resolve(html);
        });
    })
}

function buildListHtml(agencies: Array<any>): string {

    let html = "";

    for (let i = 0; i < agencies.length; i++) {
        const agency = agencies[i];

        html += `<li class="media" data-id="${agency.id}" data-url="${agency.url}" data-target="_blank"><div class="media-left pl-10">`;
        const img = `/rest/agency/getAgencyImageByAgencyID/${agency.id}/2`;

        html += `<div class="media-thumbnail img-contain img-4-3" style="background-image: url('${img}');"></div>`;
        html += "</div><div class=\"media-body py-10\">";

        html += `<h4 class="f-14 line-height-base font-weight-semibold mb-5">${agency.name}</h4>`;

        html += `<p class="mb-0">${agency.fullAddress}</p>`;

        html += "</div></li>";
    }

    return html;
}

function getAgenciesData(ids: Array<number>): JQueryPromise<any> {
    return $.ajax({
        method: "POST",
        dataType: "json",
        contentType: "application/json",
        url: "/rest/agency/getAgencyListForInfoWindow",
        data: JSON.stringify(ids)
    });
}

function getMapMarkers(): JQueryPromise<any> | undefined {

    if (!window["_serializedAgencySearchBean"])
        return;

    const searchBean = $.extend({}, JSON.parse(window["_serializedAgencySearchBean"]));

    delete searchBean["latitude"];
    delete searchBean["longitude"];

    return $.ajax({
        type: "POST",
        url: "/rest/agency/getAgenciesMarkersCommerciali",
        data: JSON.stringify(searchBean),
        contentType: "application/json; charset=utf-8",
    });
}